import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { auth, ApiError } from '../lib/api'
import { useRedirectIfAuthenticated } from '../lib/useRedirectIfAuthenticated'
import { AuthLayout, ErrorBox, Field, SubmitButton } from '../components/AuthLayout'
import { Turnstile } from '../components/Turnstile'

export function Signup() {
  const navigate = useNavigate()
  useRedirectIfAuthenticated()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [turnstileToken, setTurnstileToken] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      const res = await auth.signup(email, password, turnstileToken)
      navigate(
        `/verify?user_id=${res.user_id}&mail_configured=${res.mail_configured}&mail_sent=${res.mail_sent !== false}`,
      )
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Er ging iets mis. Probeer het opnieuw.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthLayout title="Account aanmaken">
      <ErrorBox>{error}</ErrorBox>
      <form onSubmit={onSubmit}>
        <Field label="E-mail" type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        <Field
          label="Wachtwoord"
          type="password"
          minLength={10}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Turnstile onVerify={setTurnstileToken} />
        <SubmitButton disabled={busy}>Aanmelden</SubmitButton>
      </form>
      <p className="mt-4 text-sm text-ink-soft">
        Al een account? <Link to="/login" className="text-amber">Inloggen</Link>
      </p>
    </AuthLayout>
  )
}
